(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2741],{

/***/ 63391:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 63391;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 57471:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/omnichannel/kectypes",
      function () {
        return __webpack_require__(51522);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7154);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55111);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34326);







const BreadCrumb = (props)=>{
    const { data: { appliedCssClassNames ="" , items =[]  } , fullData ={} , analyticsEvent , analyticsData  } = props;
    const isHomePage = (url)=>{
        return !url || url === _constants_index__WEBPACK_IMPORTED_MODULE_5__.HOMEPAGEURL ? "/" : url;
    };
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const ITEM_TYPE = {
        breadcrumbList: "http://schema.org/BreadcrumbList",
        listItem: "http://schema.org/ListItem"
    };
    const [eventPageName, setEventPageName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [shortURLs, setShortURLs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [componentGroup, setComponentGroup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urls = items.map((navItem)=>(0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.removeAndCleanLinkConcat)(navItem.url));
        setShortURLs(urls);
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSsr) return;
        setEventPageName(window.eventPageType);
    }, [
        isSsr
    ]);
    // #ToDo Hard coding zone value once received data from json will change
    const zone = "hero banner";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(fullData)) {
            Object.keys(fullData).map((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.TEASER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    const getEventInfo = (navItem, index)=>{
        let path = "";
        for(let i = 0; i < index; i++){
            var ref;
            path += "".concat((ref = items[i].title) === null || ref === void 0 ? void 0 : ref.toLowerCase(), " > ");
        }
        if (!isSsr) {
            var ref1;
            let eventInfo = {
                clickInternalLinks: "true",
                eventAction: eventPageName + ":" + zone + ":breadcrumb",
                eventName: eventPageName + ":" + zone + ":breadcrumb",
                eventType: eventPageName,
                internalLinkName: path + (navItem === null || navItem === void 0 ? void 0 : (ref1 = navItem.title) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                internalLinkPosition: eventPageName,
                internalLinkType: window.storeLinkType ? window.storeLinkType : eventPageName + ":breadcrumb",
                internalLinkURL: (navItem === null || navItem === void 0 ? void 0 : navItem.url) ? (navItem.url.indexOf("http") === -1 ? window.location.origin : "") + (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.removeAndCleanLinkConcat)(navItem.url) : "n/a",
                internalLinkZoneName: eventPageName + ":" + zone
            };
            if (analyticsData) {
                eventInfo = {
                    ...eventInfo,
                    ...analyticsData
                };
            }
            return JSON.stringify(eventInfo);
        }
    };
    const handleClick = (navItem)=>{
        if (analyticsEvent) {
            analyticsEvent(navItem);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "breadcrumb ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(columnClassNames),
        children: items.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
            id: "breadcrumb",
            className: "cmp-breadcrumb",
            "aria-label": "Breadcrumb",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                className: "cmp-breadcrumb__list",
                itemScope: true,
                itemType: ITEM_TYPE.breadcrumbList,
                children: items.map((navItem, index)=>{
                    const isLastItem = index === items.length - 1;
                    const isActive = navItem.active;
                    const shouldRenderSlash = !isActive && !isLastItem && !items[index + 1].active;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "cmp-breadcrumb__item",
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: ITEM_TYPE.listItem,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: isHomePage(shortURLs[index]),
                                className: "cmp-breadcrumb__item-link",
                                itemProp: "item",
                                "data-zone": zone,
                                "aria-label": navItem.title,
                                "aria-current": navItem.active ? "page" : null,
                                "data-gbh-data-layer": !analyticsEvent && !isSsr ? getEventInfo(navItem, index) : null,
                                onClick: ()=>handleClick(navItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    itemProp: "name",
                                    dangerouslySetInnerHTML: {
                                        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(navItem === null || navItem === void 0 ? void 0 : navItem.title)
                                    }
                                })
                            }),
                            shouldRenderSlash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "cmp-breadcrumb-slash",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                itemProp: "position",
                                content: index + 1
                            })
                        ]
                    }, "breadcrumb-item-".concat(index));
                })
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumb);


/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34326);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33273);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7154);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55111);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_downloadFile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58589);












const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    // useEffect(() => {
    //   let timeoutId
    //   if (!isSsr) {
    //     timeoutId = setTimeout(() => {
    //       if (!accessToken || !isGuestTokenValid()) {
    //         dispatch(getOktaToken("guest"))
    //       }
    //     }, 5000)
    //   }
    //   ;() => {
    //     clearTimeout(timeoutId)
    //   }
    // }, [accessToken, isSsr])
    // useEffect(() => {
    //   const userLoggedIn = localStorage.getItem("userLoggedIn")
    //   if (userLoggedIn === "false" || userLoggedIn === null) {
    //     if (!isGuestTokenValid()) {
    //       dispatch(getAnonymousGuestToken())
    //     }
    //   }
    // }, [])
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getCurrency)().then((currency)=>{
                        const cartPayload = {
                            currency: currency
                        };
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                        });
                    });
                }
            });
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 51522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getServerSideProps": function() { return /* binding */ getServerSideProps; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55111);
/* harmony import */ var next_i18next_serverSideTranslations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55709);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55064);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34326);
/* harmony import */ var _constants_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73350);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81169);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74859);
/* harmony import */ var _hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48375);
/* harmony import */ var _components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3282);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88751);
/* harmony import */ var _utils_findStore__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42605);
/* harmony import */ var _utils_enquiry__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(55754);















const KECTypes = (param)=>{
    let { tmpData: data , headertmp: header , footertmp: footer , globalScript , footerScript , analysticsScript , kecTypeID , analyticsData , gbhDataLayerCustom , datalayerPageName , stateWithCities , omniQRParams  } = param;
    (0,_hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.getDataLayerObj)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setDatalayerPageName */ .dN)(datalayerPageName));
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGbhDataLayerCustom */ .ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setDatalayerPageName */ .dN)(""));
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_12__/* .setGbhDataLayerCustom */ .ks)(""));
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                header: header,
                title: data === null || data === void 0 ? void 0 : data.title,
                globalScripting: globalScript,
                analysticsScript: analysticsScript,
                isOmnichannel: true,
                omniQRParams: omniQRParams
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                data: data,
                count: 0,
                breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        data: data,
                        fullData: fullData
                    }),
                stateWithCities: stateWithCities,
                omniQRParams: omniQRParams,
                isOmnichannel: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                footer: footer,
                footerScripting: footerScript,
                isOmnichannel: true,
                omniQRParams: omniQRParams
            })
        ]
    });
};
/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */ async function getServerSideProps(param) {
    let { req , res , locale , query  } = param;
    const { subcategory: id = ""  } = query;
    let { qrId ="" , placementId ="" , placementType =""  } = query;
    let placementName = "Valued Partner";
    let pageUrl;
    if (id !== "") {
        pageUrl = "/kdx/qr-store/".concat(id, ".model.json");
    } else {
        pageUrl = "/kdx/qr-store.model.json";
    }
    const isPreviewMode = req.cookies["aem-author-preview-mode"];
    const stateWithCitiesResult = await (0,_utils_findStore__WEBPACK_IMPORTED_MODULE_13__/* .getStatesAndCitiesFromServer */ .HR)();
    const response = await (0,_utils_enquiry__WEBPACK_IMPORTED_MODULE_14__/* .getPlacementName */ .d_)({
        qrCodeId: qrId,
        placementId: placementId
    });
    if (response && response.placementName) {
        placementName = response.placementName;
    }
    const stateWithCities = stateWithCitiesResult.result.data;
    const { data  } = isPreviewMode ? await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemPreviewAxiosInstance */ .IT)({
        url: _constants__WEBPACK_IMPORTED_MODULE_3__.previewContentPrefix + pageUrl,
        method: "GET"
    }) : await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemApimAxiosInstance */ .v0)({
        url: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.buildUrlForAemApim)(pageUrl),
        method: "GET"
    });
    const { data: header  } = isPreviewMode ? await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemPreviewAxiosInstance */ .IT)({
        url: "".concat(data.headerExpFrg ? data.headerExpFrg : _constants__WEBPACK_IMPORTED_MODULE_3__.headerUrl, ".model.json"),
        method: "GET"
    }) : await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemApimAxiosInstance */ .v0)({
        url: data.headerExpFrg ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.buildUrlForAemApim)("".concat(data.headerExpFrg, ".model.json")) : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.buildUrlForAemApim)("".concat(_constants__WEBPACK_IMPORTED_MODULE_3__.headerUrl, ".model.json")),
        method: "get"
    });
    const { data: footer  } = isPreviewMode ? await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemPreviewAxiosInstance */ .IT)({
        url: "".concat(data.footerExpFrg ? data.footerExpFrg : _constants__WEBPACK_IMPORTED_MODULE_3__.footerUrl, ".model.json"),
        method: "GET"
    }) : await (0,_constants_api__WEBPACK_IMPORTED_MODULE_7__/* .aemApimAxiosInstance */ .v0)({
        url: data.footerExpFrg ? (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.buildUrlForAemApim)("".concat(data.footerExpFrg, ".model.json")) : (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.buildUrlForAemApim)("".concat(_constants__WEBPACK_IMPORTED_MODULE_3__.footerUrl, ".model.json")),
        method: "GET"
    });
    const globalScript = (data === null || data === void 0 ? void 0 : data.globalScript) || null;
    const footerScript = (data === null || data === void 0 ? void 0 : data.footerScript) || null;
    const topHeadScript = (data === null || data === void 0 ? void 0 : data.topHeadScript) || null;
    const analysticsScript = (data === null || data === void 0 ? void 0 : data.adobeAnalytic) || null;
    let tmpData = {};
    if (data.pageComponentProperties) {
        tmpData = data.pageComponentProperties;
    } else {
        tmpData = data;
    }
    tmpData = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.filterBackEndJson)(tmpData);
    const analyticsData = (data === null || data === void 0 ? void 0 : data.data) || null;
    const headertmp = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.filterBackEndJson)(header);
    const footertmp = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.filterBackEndJson)(footer);
    let kecTypeID = id;
    const datalayerPageName = data === null || data === void 0 ? void 0 : data.datalayerPageName;
    const gbhDataLayerCustom = {};
    if (data === null || data === void 0 ? void 0 : data.datalayerPageName) {
        gbhDataLayerCustom.datalayerPageName = data === null || data === void 0 ? void 0 : data.datalayerPageName;
    }
    if (data === null || data === void 0 ? void 0 : data.eventPageType) {
        gbhDataLayerCustom.eventPageType = data === null || data === void 0 ? void 0 : data.eventPageType;
    }
    const omniQRParams = {
        placementName,
        qrId,
        placementId,
        placementType
    };
    return {
        props: {
            tmpData,
            headertmp,
            footertmp,
            globalScript,
            analyticsData,
            footerScript,
            topHeadScript,
            analysticsScript,
            datalayerPageName,
            gbhDataLayerCustom,
            kecTypeID,
            stateWithCities,
            omniQRParams,
            ...await (0,next_i18next_serverSideTranslations__WEBPACK_IMPORTED_MODULE_4__.serverSideTranslations)(locale, [
                "common"
            ])
        }
    };
}
/* harmony default export */ __webpack_exports__["default"] = (KECTypes);


/***/ }),

/***/ 58589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getToken; },
/* harmony export */   "S": function() { return /* binding */ downloadFile; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);



const downloadFile = (path, accessToken)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.downloadFileURL, "?fileName=").concat(path), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(accessToken)
                },
                responseType: "blob"
            });
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};
const getToken = async ()=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=guest&channel=india"));
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};


/***/ }),

/***/ 40816:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6351,1966,7333,8153,33,5709,1433,6051,9774,2888,179], function() { return __webpack_exec__(57471); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);